export enum CovidStatus {
  OPEN_ENROLLING = 'open-enrolling',
  OPEN_FULL = 'open-full',
  CLOSED = 'closed',
}

export interface IParams {
  isEnrolling: boolean
  isOpen: boolean
}

export interface IValidation {
  general?: string
}
